import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LeaderboardItem from './LeaderboardItem';
export default class LeaderboardList extends Component {
  view() {
    const {
      entries,
      state
    } = this.attrs;
    const pointsLabel = app.forum.attribute('huseyinfiliz-leaderboard.points_label') || 'Points';
    return m("div", {
      className: "LeaderboardHonorable"
    }, m("h3", {
      className: "LeaderboardHonorable-title"
    }, m("i", {
      className: "fas fa-list-ol"
    }), app.translator.trans('huseyinfiliz-leaderboard.forum.honorable.title')), m("div", {
      className: "LeaderboardHonorable-grid"
    }, entries.map(entry => m(LeaderboardItem, {
      key: entry.id(),
      entry: entry,
      pointsLabel: pointsLabel
    }))), state.hasMore && m("div", {
      className: "LeaderboardHonorable-loadMore"
    }, m(Button, {
      className: "Button",
      loading: state.loadingMore,
      onclick: () => state.loadMore()
    }, app.translator.trans('huseyinfiliz-leaderboard.forum.list.load_more'))));
  }
}
flarum.reg.add('huseyinfiliz-leaderboard', 'forum/components/LeaderboardList', LeaderboardList);